import { render, staticRenderFns } from "./session-items.vue?vue&type=template&id=0e795bba"
import script from "./session-items.vue?vue&type=script&lang=ts"
export * from "./session-items.vue?vue&type=script&lang=ts"
import style0 from "./session-items.vue?vue&type=style&index=0&id=0e795bba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports